import {
    FinancialEntityOwnershipType,
    FinancialEntityType,
    GoalAccountStructure,
    GoalFieldsFragment,
    GoalType,
    LinkStatus,
    ShareStatus,
} from '../graphql/generated';

export const sampleGoals: GoalFieldsFragment[] = [
    {
        id: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
        name: 'Cash Management',
        type: 'CASH_MANAGEMENT' as GoalType,
        typeInfo: {},
        shareStatus: 'SHARED' as ShareStatus,
        targetAmount: null,
        targetDate: null,
        accountStructure: 'SPLIT' as GoalAccountStructure,
        financialEntities: [
            {
                id: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
                type: 'PlentyGoalAccount' as FinancialEntityType,
                name: null,
                info: {
                    feType: 'PlentyGoalAccount',
                    riskScore: 0,
                    investmentType: 'HIGH_YIELD_CASH',
                    assetClassExposures: [
                        {
                            name: 'MUTUAL_FUND',
                            fraction: 0.9999399240484831,
                        },
                        {
                            name: 'COMMON_STOCK',
                            fraction: 0.00006007595151694583,
                        },
                    ],
                    accountType: 'BROKERAGE',
                },
                linkStatus: 'MANUAL' as LinkStatus,
                linkedFields: null,
                mask: null,
                institution: null,
                latestSnapshot: {
                    id: 'fadb4128-3fc3-47cb-8864-5584d7ae5842',
                    dateTime: '2024-04-08T12:30:41.032196+00:00',
                    isBalanceDateAccurate: true,
                    balance: 130710,
                    info: {
                        feType: 'PlentyGoalAccount',
                        costBasis: 1510000,
                        simpleReturn: 0.0009,
                        totalFeesAmount: 54,
                        withdrawalsAmount: 0,
                        timeWeightedReturn: 0.000006212458748322547,
                        contributionsAmount: 1510000,
                        totalDividendAmount: 1157,
                        totalInterestAmount: 193,
                    },
                    __typename: 'FinancialEntitySnapshot',
                },
                earliestSnapshot: {
                    id: '3c027770-0481-4875-b089-1253b232a3ff',
                    dateTime: '2024-02-20T17:38:22.469951+00:00',
                    balance: 0,
                    __typename: 'FinancialEntitySnapshot',
                },
                goalAccountOnboarding: null,
                transactionSchedulesByDestinationId: [],
                transactionSchedulesBySourceId: [],
                transactionsByDestinationId: [],
                transactionsBySourceId: [],
                isMine: true,
                ownersIncludeMyself: true,
                shareStatus: 'SHARED' as ShareStatus,
                goalId: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                goal: {
                    id: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                    name: 'High Yield Savings',
                    type: 'CASH_MANAGEMENT' as GoalType,
                    accountStructure: 'SPLIT' as GoalAccountStructure,
                    __typename: 'Goal',
                },
                createdAt: '2024-02-20T17:38:21.663545+00:00',
                updatedAt: '2024-04-08T12:30:43.015848+00:00',
                deletedAt: null,
                ownershipType: 'INDIVIDUAL' as FinancialEntityOwnershipType,
                jointOwnerPartnershipId: null,
                externalAccountConsentExistsForUser: false,
                invertTransactionEntryAmounts: false,
                __typename: 'FinancialEntity',
            },
        ],
        goalAccountOnboardings: [
            {
                id: '887ce020-9391-4dad-a0d9-1f56256a0de4',
                info: {
                    infoType: 'DEFAULT',
                    riskScore: 0,
                    investmentType: 'HIGH_YIELD_CASH',
                    fundingAccountId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
                    lastCompletedStep: 'PLAN',
                    initialDepositPlan: 1000000,
                    transactionSchedulePlan: {
                        amount: 0,
                        startDate: '2024-03-20',
                        recurrence: {
                            freq: 'MONTHLY',
                            interval: 1,
                        },
                    },
                },
                confirmedAt: '2024-02-20T17:38:21.666+00:00',
                approvedAt: null,
                isMine: true,
                financialEntityId: null,
                createdAt: '2024-02-22T17:26:44.280087+00:00',
                updatedAt: '2024-04-01T08:56:50.490044+00:00',
                __typename: 'GoalAccountOnboarding',
            },
        ],
        isMine: true,
        updatedAt: '2024-03-15T18:52:37.465546+00:00',
        createdAt: '2024-02-20T17:37:59.112791+00:00',
        deletedAt: null,
        isHidden: false,
        onboardingVersion: 'v1',
        __typename: 'Goal',
    },
    {
        id: '87f12b8d-c36d-431f-9599-2771869febdc',
        name: 'Home Down Payment',
        type: 'HOME_DOWN_PAYMENT' as GoalType,
        typeInfo: {},
        shareStatus: 'SHARED' as ShareStatus,
        targetAmount: null,
        targetDate: null,
        accountStructure: 'SPLIT' as GoalAccountStructure,
        financialEntities: [
            {
                id: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
                type: 'PlentyGoalAccount' as FinancialEntityType,
                name: null,
                info: {
                    feType: 'PlentyGoalAccount',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    assetClassExposures: [
                        {
                            name: 'MUTUAL_FUND',
                            fraction: 0.9999399240484831,
                        },
                        {
                            name: 'COMMON_STOCK',
                            fraction: 0.00006007595151694583,
                        },
                    ],
                    accountType: 'BROKERAGE',
                },
                linkStatus: 'MANUAL' as LinkStatus,
                linkedFields: null,
                mask: null,
                institution: null,
                latestSnapshot: {
                    id: 'fadb4128-3fc3-47cb-8864-5584d7ae5842',
                    dateTime: '2024-04-08T12:30:41.032196+00:00',
                    isBalanceDateAccurate: true,
                    balance: 400575,
                    info: {
                        feType: 'PlentyGoalAccount',
                        costBasis: 1510000,
                        simpleReturn: 0.0009,
                        totalFeesAmount: 54,
                        withdrawalsAmount: 0,
                        timeWeightedReturn: 0.000006212458748322547,
                        contributionsAmount: 1510000,
                        totalDividendAmount: 1157,
                        totalInterestAmount: 193,
                    },
                    __typename: 'FinancialEntitySnapshot',
                },
                earliestSnapshot: {
                    id: '3c027770-0481-4875-b089-1253b232a3ff',
                    dateTime: '2024-02-20T17:38:22.469951+00:00',
                    balance: 0,
                    __typename: 'FinancialEntitySnapshot',
                },
                goalAccountOnboarding: null,
                transactionSchedulesByDestinationId: [],
                transactionSchedulesBySourceId: [],
                transactionsByDestinationId: [],
                transactionsBySourceId: [],
                isMine: true,
                ownersIncludeMyself: true,
                shareStatus: 'SHARED' as ShareStatus,
                goalId: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                goal: {
                    id: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                    name: 'High Yield Savings',
                    type: 'CASH_MANAGEMENT' as GoalType,
                    __typename: 'Goal',
                    accountStructure: 'SPLIT' as GoalAccountStructure,
                },
                createdAt: '2024-02-20T17:38:21.663545+00:00',
                updatedAt: '2024-04-08T12:30:43.015848+00:00',
                deletedAt: null,
                ownershipType: 'INDIVIDUAL' as FinancialEntityOwnershipType,
                jointOwnerPartnershipId: null,
                externalAccountConsentExistsForUser: false,
                invertTransactionEntryAmounts: false,
                __typename: 'FinancialEntity',
            },
        ],
        goalAccountOnboardings: [
            {
                id: '887ce020-9391-4dad-a0d9-1f56256a0de4',
                info: {
                    infoType: 'DEFAULT',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    fundingAccountId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
                    lastCompletedStep: 'PLAN',
                    initialDepositPlan: 1000000,
                    transactionSchedulePlan: {
                        amount: 0,
                        startDate: '2024-03-20',
                        recurrence: {
                            freq: 'MONTHLY',
                            interval: 1,
                        },
                    },
                },
                confirmedAt: '2024-02-20T17:38:21.666+00:00',
                approvedAt: null,
                isMine: true,
                financialEntityId: null,
                createdAt: '2024-02-22T17:26:44.280087+00:00',
                updatedAt: '2024-04-01T08:56:50.490044+00:00',
                __typename: 'GoalAccountOnboarding',
            },
        ],
        isMine: true,
        updatedAt: '2024-03-15T18:52:37.465546+00:00',
        createdAt: '2024-02-20T17:37:59.112791+00:00',
        deletedAt: null,
        isHidden: false,
        onboardingVersion: 'v1',
        __typename: 'Goal',
    },
    {
        id: '320c1a25-a047-4635-81bb-72a76257ecd7',
        name: 'Honeymoon',
        type: 'VACATION' as GoalType,
        typeInfo: {},
        shareStatus: 'SHARED' as ShareStatus,
        targetAmount: null,
        targetDate: null,
        accountStructure: 'JOINT' as GoalAccountStructure,
        financialEntities: [
            {
                id: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
                type: 'PlentyGoalAccount' as FinancialEntityType,
                name: null,
                info: {
                    feType: 'PlentyGoalAccount',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    assetClassExposures: [
                        {
                            name: 'MUTUAL_FUND',
                            fraction: 0.9999399240484831,
                        },
                        {
                            name: 'COMMON_STOCK',
                            fraction: 0.00006007595151694583,
                        },
                    ],
                    accountType: 'BROKERAGE',
                },
                linkStatus: 'MANUAL' as LinkStatus,
                linkedFields: null,
                mask: null,
                institution: null,
                latestSnapshot: {
                    id: 'fadb4128-3fc3-47cb-8864-5584d7ae5842',
                    dateTime: '2024-04-08T12:30:41.032196+00:00',
                    isBalanceDateAccurate: true,
                    balance: 255125,
                    info: {
                        feType: 'PlentyGoalAccount',
                        costBasis: 1510000,
                        simpleReturn: 0.0009,
                        totalFeesAmount: 54,
                        withdrawalsAmount: 0,
                        timeWeightedReturn: 0.000006212458748322547,
                        contributionsAmount: 1510000,
                        totalDividendAmount: 1157,
                        totalInterestAmount: 193,
                    },
                    __typename: 'FinancialEntitySnapshot',
                },
                earliestSnapshot: {
                    id: '3c027770-0481-4875-b089-1253b232a3ff',
                    dateTime: '2024-02-20T17:38:22.469951+00:00',
                    balance: 0,
                    __typename: 'FinancialEntitySnapshot',
                },
                goalAccountOnboarding: null,
                transactionSchedulesByDestinationId: [],
                transactionSchedulesBySourceId: [],
                transactionsByDestinationId: [],
                transactionsBySourceId: [],
                isMine: true,
                ownersIncludeMyself: true,
                shareStatus: 'SHARED' as ShareStatus,
                goalId: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                goal: {
                    id: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                    name: 'High Yield Savings',
                    type: 'CASH_MANAGEMENT' as GoalType,
                    __typename: 'Goal',
                    accountStructure: 'JOINT' as GoalAccountStructure,
                },
                createdAt: '2024-02-20T17:38:21.663545+00:00',
                updatedAt: '2024-04-08T12:30:43.015848+00:00',
                deletedAt: null,
                ownershipType: 'INDIVIDUAL' as FinancialEntityOwnershipType,
                jointOwnerPartnershipId: null,
                externalAccountConsentExistsForUser: false,
                invertTransactionEntryAmounts: false,
                __typename: 'FinancialEntity',
            },
        ],
        goalAccountOnboardings: [
            {
                id: '887ce020-9391-4dad-a0d9-1f56256a0de4',
                info: {
                    infoType: 'DEFAULT',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    fundingAccountId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
                    lastCompletedStep: 'PLAN',
                    initialDepositPlan: 1000000,
                    transactionSchedulePlan: {
                        amount: 0,
                        startDate: '2024-03-20',
                        recurrence: {
                            freq: 'MONTHLY',
                            interval: 1,
                        },
                    },
                },
                confirmedAt: '2024-02-20T17:38:21.666+00:00',
                approvedAt: null,
                isMine: true,
                financialEntityId: null,
                createdAt: '2024-02-22T17:26:44.280087+00:00',
                updatedAt: '2024-04-01T08:56:50.490044+00:00',
                __typename: 'GoalAccountOnboarding',
            },
        ],
        isMine: true,
        updatedAt: '2024-03-15T18:52:37.465546+00:00',
        createdAt: '2024-02-20T17:37:59.112791+00:00',
        deletedAt: null,
        isHidden: false,
        onboardingVersion: 'v1',
        __typename: 'Goal',
    },
    {
        id: '99a83849-e1f0-414c-b4a7-75e44c564af3',
        name: 'General Investing',
        type: 'GENERAL_INVESTING' as GoalType,
        typeInfo: {},
        shareStatus: 'SHARED' as ShareStatus,
        targetAmount: null,
        targetDate: null,
        accountStructure: 'SPLIT' as GoalAccountStructure,
        financialEntities: [
            {
                id: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
                type: 'PlentyGoalAccount' as FinancialEntityType,
                name: null,
                info: {
                    feType: 'PlentyGoalAccount',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    assetClassExposures: [
                        {
                            name: 'MUTUAL_FUND',
                            fraction: 0.9999399240484831,
                        },
                        {
                            name: 'COMMON_STOCK',
                            fraction: 0.00006007595151694583,
                        },
                    ],
                    accountType: 'BROKERAGE',
                },
                linkStatus: 'MANUAL' as LinkStatus,
                linkedFields: null,
                mask: null,
                institution: null,
                latestSnapshot: {
                    id: 'fadb4128-3fc3-47cb-8864-5584d7ae5842',
                    dateTime: '2024-04-08T12:30:41.032196+00:00',
                    isBalanceDateAccurate: true,
                    balance: 8472306,
                    info: {
                        feType: 'PlentyGoalAccount',
                        costBasis: 1510000,
                        simpleReturn: 0.0009,
                        totalFeesAmount: 54,
                        withdrawalsAmount: 0,
                        timeWeightedReturn: 0.000006212458748322547,
                        contributionsAmount: 1510000,
                        totalDividendAmount: 1157,
                        totalInterestAmount: 193,
                    },
                    __typename: 'FinancialEntitySnapshot',
                },
                earliestSnapshot: {
                    id: '3c027770-0481-4875-b089-1253b232a3ff',
                    dateTime: '2024-02-20T17:38:22.469951+00:00',
                    balance: 0,
                    __typename: 'FinancialEntitySnapshot',
                },
                goalAccountOnboarding: null,
                transactionSchedulesByDestinationId: [],
                transactionSchedulesBySourceId: [],
                transactionsByDestinationId: [],
                transactionsBySourceId: [],
                isMine: true,
                ownersIncludeMyself: true,
                shareStatus: 'SHARED' as ShareStatus,
                goalId: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                goal: {
                    id: 'c3bd195b-b4e7-4756-9f18-052220e278cf',
                    name: 'High Yield Savings',
                    type: 'CASH_MANAGEMENT' as GoalType,
                    accountStructure: 'SPLIT' as GoalAccountStructure,
                    __typename: 'Goal',
                },
                createdAt: '2024-02-20T17:38:21.663545+00:00',
                updatedAt: '2024-04-08T12:30:43.015848+00:00',
                deletedAt: null,
                ownershipType: 'INDIVIDUAL' as FinancialEntityOwnershipType,
                jointOwnerPartnershipId: null,
                externalAccountConsentExistsForUser: false,
                invertTransactionEntryAmounts: false,
                __typename: 'FinancialEntity',
            },
        ],
        goalAccountOnboardings: [
            {
                id: '887ce020-9391-4dad-a0d9-1f56256a0de4',
                info: {
                    infoType: 'DEFAULT',
                    riskScore: 0,
                    investmentType: 'DIRECT_INDEXING',
                    fundingAccountId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
                    lastCompletedStep: 'PLAN',
                    initialDepositPlan: 1000000,
                    transactionSchedulePlan: {
                        amount: 0,
                        startDate: '2024-03-20',
                        recurrence: {
                            freq: 'MONTHLY',
                            interval: 1,
                        },
                    },
                },
                confirmedAt: '2024-02-20T17:38:21.666+00:00',
                approvedAt: null,
                isMine: true,
                financialEntityId: null,
                createdAt: '2024-02-22T17:26:44.280087+00:00',
                updatedAt: '2024-04-01T08:56:50.490044+00:00',
                __typename: 'GoalAccountOnboarding',
            },
        ],
        isMine: true,
        updatedAt: '2024-03-15T18:52:37.465546+00:00',
        createdAt: '2024-02-20T17:37:59.112791+00:00',
        deletedAt: null,
        isHidden: false,
        onboardingVersion: 'v1',
        __typename: 'Goal',
    },
];
